
/**
 * Lightweight placeholder for global modals (login etc).
 * Replace with your real Modal implementation when ready.
 */
const Modals = ({ handleSignIn = () => {}, email = '', setEmail = () => {}, password = '', setPassword = () => {}, loginError = '' }) => {
  return null; // no UI by default; prevents invalid import errors
};

export default Modals;